import React, { useState } from 'react';
import Button from '$/components/base/Button';
import classNames from 'classnames';
import HomeInputPanel from '@/pages/--roboneo/home/components/BaseHomeNew/HomeInputPanel';
import useHomeInputPanelComposer from '@/pages/--roboneo/home/components/BaseHomeNew/useHomeInputPanelComposer';
import GradientBorder from './GradientBorder';
import style from './index.module.scss';

export default function MainInput() {
  // const [hideGradient, setHideGradient] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [transitionend, setTransitionend] = useState(false);
  const inputComposer = useHomeInputPanelComposer({
    trackLocation: 'official_page',
    enableSkillSelect: true,
    forceShowModelSelect: true,
  });

  const onTransitionEnd = (e: React.TransitionEvent<HTMLDivElement>) => {
    if (e.propertyName === 'width') {
      setTransitionend((e.target as HTMLDivElement).clientWidth >= 500);
      // setHideGradient(false);
    }
  };

  /** 渲染海外官网首屏输入框的 Generate 提交按钮。 */
  const renderGenerateButton = ({ disabled, onClick }: { disabled: boolean; onClick: () => void; }) => {
    return (
      <Button
        type="primary"
        className={classNames(style.generate_button, style.generate_button_main_screen)}
        disabled={disabled}
        onClick={() => {
          window.mtstat?.track('roboneo_official_page_icon_click', {
            source: 'generate',
            icon_id: 'generate',
          });
          onClick();
        }}
      >
        Generate
      </Button>
    );
  };

  return (
    <div
      className={classNames(style.main_input_box)}
      onMouseEnter={() => {
        setHovered(true);
        // setHideGradient(true);
      }}
      style={{
        height: hovered ? 'max-content' : '56px',
        minHeight: hovered ? '160px' : '56px',
        width: hovered ? '630px' : '448px',
        borderRadius: hovered ? '24px' : '56px',
      }}
      onTransitionEnd={onTransitionEnd}
    >
      {hovered
        ? (
          <div className={style.input_box}>
            <GradientBorder borderRadius={24} className={style.gradient_border} />
            {transitionend && (
              <HomeInputPanel
                inputPlaceholder="Describe an image and click generate..."
                inputComposer={inputComposer}
                trackLocation="official_page"
                className={style.home_input_chat}
                renderSubmitButton={renderGenerateButton}
                // modelSelectSlot={() => <div>Model Select</div>}
                // selectModeSlot={() => <div>Select Mode</div>}
              />
            )}

          </div>
        )
        : (
          <div
            className={style.mini_input_box}
          >
            <GradientBorder borderRadius={26} className={style.gradient_border} />
            <span>Describe an image and click generate...</span>
            <Button type="primary" className={style.generate_button}>
              Generate
            </Button>
          </div>
        )}

    </div>
  );
}
